module.exports = "\r\n// we use this vertex shader for the post process steps. All we do is copy the uv value and set position appropriately\r\n\r\nvarying vec2 f_uv;\r\nvoid main() {\r\n    f_uv = uv;\r\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/glsl/pass-vert.glsl
// module id = 2
// module chunks = 0